import { getImageUrl } from '@app/utils/url/getImageUrl'

import { IconProps } from './types'

export const Icon = ({ path, alt = '', style, className }: IconProps) => {
  const imgUrl = getImageUrl(path)

  return path && <img src={imgUrl} alt={alt} style={style} className={className} draggable={false} />
}
